export default [
	{
		settings: true,
		text: "Division ID",
		value: "id",
		func: true,
		valueFilter: 'filter_id',
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Customer name",
		value: "name",
		func: true,
		valueFilter: 'filter_name',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Created date",
		value: "created_at",
		func: true,
		valueFilter: 'filter_created_at',
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Sales manager",
		value: "sale_manager",
		func: true,
		valueFilter: 'filter_sale_manager',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Email",
		value: "email",
		func: true,
		valueFilter: 'filter_email',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Phone",
		value: "phone",
		func: true,
		valueFilter: 'filter_phone',
		model: { value: 'list' },
		sortable: true,
		modValue: 'phoneUSA',
	},
	{
		settings: true,
		text: "Frozen",
		value: "frozen",
		func: true,
		valueFilter: 'filter_frozen',
		model: { value: 'list' },
		sortable: true,
		align: 'center',
		isStatus: true,
	},
	{
		settings: true,
		text: "Services",
		value: "services",
		filterSplit: true,
		func: true,
		valueFilter: 'filter_services',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	/*		{
		settings: true,
		text: "Date started",
		value: "started",
		func: true,
		valueFilter: 'filter_started',
		model: { value: 'date' },
		sortable: true,
		toLeft: true
	},*/
	{
		settings: true,
		text: "Balance",
		value: "balance",
		colorDetected: true,
		func: true,
		valueFilter: 'filter_balance',
		model: { value: 'number' },
		sortable: true,
		modText: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Find us",
		value: "find_us",
		colorDetected: true,
		func: true,
		valueFilter: 'filter_find_us',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10, 9 ] },
				value: 'edit',
				text: 'Edit customer',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: {
					or: [ 11 ]
				},
				value: 'delete',
				text: 'Delete customer',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
